import { render, staticRenderFns } from "./SearchFilterTokens-v2.vue?vue&type=template&id=13c00186&scoped=true&"
import script from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
export * from "./SearchFilterTokens-v2.vue?vue&type=script&lang=js&"
import style0 from "./SearchFilterTokens-v2.vue?vue&type=style&index=0&id=13c00186&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13c00186",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13c00186')) {
      api.createRecord('13c00186', component.options)
    } else {
      api.reload('13c00186', component.options)
    }
    module.hot.accept("./SearchFilterTokens-v2.vue?vue&type=template&id=13c00186&scoped=true&", function () {
      api.rerender('13c00186', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2QqgahwH2wRWz/JS/comp/SearchFilterTokens-v2.vue"
export default component.exports